module.exports = __webpack_public_path__ + "img/peugeot_43s.2f2bfaae.jpg";